import { Injectable } from '@angular/core';

export enum LicenceModules {
  /* eslint-disable no-bitwise */
  Platform = 1 << 0,
  Rbi = 1 << 1,
  Rcm = 1 << 2,
  /* eslint-enable no-bitwise */
}

@Injectable()
export class LicenceModuleDisplayNameProvider {
  private moduleNames = [
    { key: LicenceModules.Platform, val: 'IDMS' },
    { key: LicenceModules.Rbi, val: 'RBI' },
    { key: LicenceModules.Rcm, val: 'MO' },
  ];

  public obtain(mod: LicenceModules): string {
    const result = this.moduleNames.find(x => x.key === mod);

    if (result) {
      return result.val;
    }

    return LicenceModules[mod];
  }
}
